import type { Level, UserProfile } from "../gamification";
import type { Installment } from "../installment";

export const TrinketNames = {
  GAMIFICATION: "GAMIFICATION",
  INSTALLMENTS: "INSTALLMENTS",
} as const;

export type TrinketName = (typeof TrinketNames)[keyof typeof TrinketNames];

interface GamificationTrinketData extends UserProfile {
  nextLevel?: Level;
}

export interface GamificationTrinket {
  name: typeof TrinketNames.GAMIFICATION;
  data: GamificationTrinketData;
}

interface InstallmentTrinketData {
  nextInstallment?: Installment;
}

export interface InstallmentsTrinketData {
  name: typeof TrinketNames.INSTALLMENTS;
  data: InstallmentTrinketData;
}

export type Trinket = GamificationTrinket | InstallmentsTrinketData;
